import styled from "@emotion/styled";
import React, { CSSProperties } from "react";
import { classnames } from "../../lib";

const Grid = styled.div`
  display: grid;
  height: fit-content;

  & > *:nth-child(1) {
    border: none;
  }
  & > * {
    border-right: solid 1px black;
    border-bottom: solid 1px black;
  }
  .legend-left {
    border-left: solid 1px black;
    &.first {
      border-top: solid 1px black;
      border-top-left-radius: 5px;
    }
    &.last {
      border-bottom-left-radius: 5px;
    }
  }
  .legend-top {
    border-top: solid 1px black;
    &.first {
      border-left: solid 1px black;
      border-top-left-radius: 5px;
    }
    &.last {
      border-top-right-radius: 5px;
    }
  }
`;

export function XTable({
  data: dataRaw,
  topHeaders: topHeadersRaw,
  headerStyle,
  cellStyle,
  transpose,
}: {
  data: React.ReactNode[][];
  topHeaders: React.ReactNode[];
  headerStyle?: CSSProperties;
  cellStyle?: CSSProperties;
  transpose?: boolean;
}) {
  if (!dataRaw.at(0)) {
    throw new Error("data cannot be empty");
  }
  const data = transpose
    ? topHeadersRaw.map((topHeader, headerIndex) => [
        topHeader,
        ...dataRaw.map((line) => line[headerIndex + 1]),
      ])
    : dataRaw;
  const topHeaders = transpose ? dataRaw.map((line) => line[0]) : topHeadersRaw;
  return (
    <Grid
      style={{
        gridTemplateColumns: ["1fr", ...topHeaders.map(() => "1fr")].join(" "),
      }}
    >
      <div></div>
      {topHeaders.map((header, index) => (
        <div
          key={index}
          className={classnames({
            title: true,
            "legend-top": true,
            first: index === 0,
            last: index === topHeaders.length - 1,
          })}
          style={headerStyle}
        >
          {header}
        </div>
      ))}
      {data.flatMap((line, lineIndex) => {
        return line.map((cell, cellIndex) => {
          const isHeader = cellIndex === 0;
          return (
            <div
              key={`${lineIndex}_${cellIndex}`}
              className={classnames({
                title: isHeader,
                "legend-left": isHeader,
                first: lineIndex === 0,
                last: lineIndex === data.length - 1,
              })}
              style={isHeader ? headerStyle : cellStyle}
            >
              {cell}
            </div>
          );
        });
      })}
    </Grid>
  );
}
